import ApplicantManual from '@/components/services/CorrectTranslation/Applicant/Manual/index.vue';

import TranslatedDocument from '@/components/services/CorrectTranslation/TranslatedDocument.vue';
import AccountBankDetails from '@/components/services/CorrectTranslation/AccountBankDetails.vue';
import StepDocuments from '@/components/services/common/StepDocuments.vue';

import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType.vue';
import SubjectFillType from '@/components/services/common/SubjectFillType.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const commonSteps: unknown[] = [
  TranslatedDocument,
  AccountBankDetails,
  StepDocuments,
];
const steps: unknown[] = [ApplicantManual, ...commonSteps];

const mrpaSteps: unknown[] = [
  SelectSubjectFillType,
  SubjectFillType,
  ...commonSteps,
];

export const correctTranslationSteps: unknown[] = isMrpaEnable(
  StatementType.CORRECT_TRANSLATION
)
  ? mrpaSteps
  : steps;
